import React, { useState } from "react";

import { Button, Typography } from "@material-ui/core";

import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

import firebase from "../../services/firebase";
import { CONTACT_LINK } from "../../constants";

export default () => {
  const classes = {};
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const handleSubmit = async () => {
    await firebase.auth().sendPasswordResetEmail(email);
    setDone(true);
  };
  if (done)
    return (
      <>
        <Typography variant="h5">Password Reset</Typography>
        <Typography variant="body1">
          Please <a href={CONTACT_LINK}>contact us</a> if you do not receive our
          email within a few minutes.
        </Typography>
      </>
    );

  return (
    <>
      <Typography variant="h5">Password Reset</Typography>
      <Typography variant="body1">
        Enter your email below, and we'll send you an email with a reset link.
      </Typography>

      <ValidatorForm className={classes.container} onSubmit={handleSubmit}>
        <TextValidator
          autoFocus
          className={classes.textField}
          id="name"
          label="Email Address"
          onChange={(event) => setEmail(event.target.value)}
          type="email"
          variant="outlined"
          margin="normal"
          fullWidth
          value={email}
          validators={["required", "isEmail"]}
          errorMessages={["this field is required", "must be valid email"]}
        />
        <Button
          fullWidth
          type="submit"
          variant="contained"
          color="primary"
          style={{ margin: "8px 0" }}
        >
          Reset Password
        </Button>
      </ValidatorForm>

      <Typography variant="body1">
        If you're having trouble resetting your password please{" "}
        <a href={CONTACT_LINK}>reach out</a>.
      </Typography>
    </>
  );
};
